module.exports = __webpack_public_path__ + "static/img/6.f54b951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/6.png
// module id = VgGt
// module chunks = 0